import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiStatDTO extends StrapiDynamicZoneComponentDTO {
  value: string;
  label: string;
}

export class StatDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  value: string;
  label: string;
}
